// extracted by mini-css-extract-plugin
export default {"header":"OtherIncome_header__S5zht"};